import _classCallCheck from "/builder/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builder/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builder/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builder/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { extension, ExtensionPriority, NodeExtension, ExtensionTag } from '@remirror/core';

var _dec, _class;
/**
 * The default text passed into the prosemirror schema.
 *
 * Extra attributes are not allowed on the text extension.
 *
 * @core
 */


var TextExtension = (_dec = extension({
  disableExtraAttributes: true,
  defaultPriority: ExtensionPriority.Medium
}), _dec(_class = /*#__PURE__*/function (_NodeExtension) {
  _inherits(TextExtension, _NodeExtension);

  var _super = _createSuper(TextExtension);

  function TextExtension() {
    _classCallCheck(this, TextExtension);

    return _super.apply(this, arguments);
  }

  _createClass(TextExtension, [{
    key: "name",
    get: function get() {
      return 'text';
    }
  }, {
    key: "createTags",
    value: function createTags() {
      return [ExtensionTag.InlineNode];
    }
  }, {
    key: "createNodeSpec",
    value: function createNodeSpec() {
      return {};
    }
  }]);

  return TextExtension;
}(NodeExtension)) || _class);
export { TextExtension };